"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const Config_1 = __importDefault(require("utils/Config"));
const HelperUtils_1 = require("utils/HelperUtils");
const AWSImage_1 = __importDefault(require("components/design-system/AWSImage"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const Badge = ({ dataCy, isEditable, withRemove, iconUrl, colorHex, bgColorHex, title, content, children, className, onClick, iconLeft, defaultPointer, useEvent, truncate, imageVariant, iconLeftColor, customMaxWidth, showEditIcon, setIsEllipsis, useStopPropagation = true, typographyClass }) => {
    const [onHover, setOnHover] = (0, react_1.useState)(false);
    const BadgeCN = (0, classnames_template_literals_1.default)(`
    typography-h100
    flex items-center
    ${className ? className : ''}
    ${defaultPointer ? 'cursor-pointer' : isEditable ? 'cursor-pointer' : ''}
  `);
    const contentWrapperCN = (0, classnames_template_literals_1.default)(`
    px-[8px] py-[2px]
    header-text
    flex
    items-center
    rounded-[4px]
    ${truncate ? (customMaxWidth ? customMaxWidth : 'max-w-[240px]') : ''}
  `);
    const imageCN = (0, classnames_template_literals_1.default)(`
    w-[16px] h-[16px]
    mr-[4px]
    ${imageVariant == 'rounded-full' && 'rounded-full'}
    ${imageVariant == 'rounded' && 'rounded'}
  `);
    const onClickBadge = (e) => {
        if (useStopPropagation) {
            e.stopPropagation();
        }
        onClick && isEditable && onClick && onClick();
        useEvent && onClick && onClick();
    };
    return (react_1.default.createElement("div", { "data-cy": dataCy, className: BadgeCN, onMouseEnter: () => setOnHover(true), onMouseLeave: () => setOnHover(false), onClick: (e) => onClickBadge(e) },
        react_1.default.createElement("div", { className: contentWrapperCN, style: { color: `#${colorHex}`, background: `#${bgColorHex}` } },
            iconLeft && (react_1.default.createElement(SVGIcon_1.default, { size: 16, iconName: iconLeft, fillColor: iconLeftColor, customClass: "mr-[4px]" })),
            iconUrl && react_1.default.createElement(AWSImage_1.default, { src: iconUrl, className: imageCN }),
            title && (react_1.default.createElement("span", { className: "typography-h200 mr-[4px]", style: { color: `#${colorHex}` } },
                `${title}: `,
                ' ')),
            (children || content) && (react_1.default.createElement("p", { ref: (ref) => setIsEllipsis &&
                    ref &&
                    setIsEllipsis(ref?.offsetWidth < ref?.scrollWidth), className: `${typographyClass || 'typography-h100'} ${truncate ? 'truncate' : ''}` }, children || content))),
        isEditable && onClick && onHover && showEditIcon && (react_1.default.createElement(AWSImage_1.default, { className: "w-[16px] h-[16px] mr-[4px]", src: Config_1.default.asset.createObjective.iconEditSidebar })),
        withRemove && (react_1.default.createElement(SVGIcon_1.default, { fillColor: "var(--n-600)", size: 16, iconName: "icon-clear", customClass: "ml-[4px]", onClick: withRemove?.onClick }))));
};
Badge.defaultProps = {
    dataCy: '',
    isEditable: false,
    iconUrl: '',
    colorHex: (0, HelperUtils_1.getCssVariableValue)('--n-800'),
    bgColorHex: (0, HelperUtils_1.getCssVariableValue)('--n-300'),
    title: '',
    content: '',
    className: '',
    onClick: () => undefined,
    iconLeft: '',
    defaultPointer: false,
    useEvent: false,
    truncate: false,
    imageVariant: '',
    iconLeftColor: 'var(--n-600)',
    customMaxWidth: '',
    showEditIcon: true,
    setIsEllipsis: () => undefined
};
exports.default = Badge;
